import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  inputFloatLabel: {
    description: 'editFilterViewModal.inputFloatLabel',
    defaultMessage: 'View Name',
    id: 'MY0VGm',
  },
  deleteView: {
    description: 'deleteFilterViewModal.deleteFilterView',
    defaultMessage: 'Delete this view',
    id: '+tdY9f',
  },
  viewManagedBy: {
    description: 'editFilterViewModal.viewManagedBy',
    defaultMessage: 'View managed by {gridConfigOwnerUsername}',
    id: 'TSTsWR',
  },
});
